var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-empty-list"},[_c('div',{staticClass:"wp-empty-list__text",class:{ 'wp-empty-list__text_no-padding': _vm.noPadding },domProps:{"innerHTML":_vm._s(_vm.emptyTitle)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }